import { render } from "./LoyaltyProductFormPage.vue?vue&type=template&id=10954696&scoped=true&ts=true"
import script from "./LoyaltyProductFormPage.vue?vue&type=script&lang=ts"
export * from "./LoyaltyProductFormPage.vue?vue&type=script&lang=ts"

import "./LoyaltyProductFormPage.vue?vue&type=style&index=0&id=10954696&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10954696"]])

export default __exports__